import React, { useContext, useState } from "react";
import {
  Button,
  Caption,
  Card,
  Collapsible,
  DisplayText,
  // Link,
  ProgressBar,
  SkeletonBodyText,
  Stack,
  TextStyle,
} from "@shopify/polaris";
import { PrivateContext } from "lib/context";
import { baseHelper } from "lib/helpers";
import { StyledCardHeader } from "asset/styles/globalStyle";
import { StyledPlanCard, InnerCard } from "./planCardStyle";

const OperatorPlanCard = () => {
  const { cms, currentUser, isLoading } = useContext(PrivateContext);
  const [openPlanCard, setOpenPlanCard] = useState(true);

  const { plan = {}, products = {}, vendors = {} } = currentUser;
  const { code = "", name = "", price = "" } = plan; // , isChargebee = false
  const { max: maxProduct = "", used = "" } = products;
  const { max: maxVendor = "", associated = "" } = vendors;
  const planURL = "/update/plan"; // isChargebee ? "/update/plan" : "/plan";

  if (isLoading) {
    return <SkeletonBodyText lines={3} />;
  }

  return (
    <Card>
      <StyledPlanCard>
        <StyledCardHeader>
          <Card.Header title={cms("common.label.planCard.title")}>
            <Button
              plain
              disclosure={openPlanCard ? "up" : "down"}
              onClick={() => {
                setOpenPlanCard(!openPlanCard);
              }}
            >
              {openPlanCard ? cms("common.label.hide") : cms("common.label.show")}
            </Button>
          </Card.Header>
        </StyledCardHeader>
        <Collapsible
          open={openPlanCard}
          id="collapsiblePlanCard"
          transition={{ duration: "150ms", timingFunction: "ease" }}
        >
          <Card>
            <InnerCard className="inner-card">
              <Card.Section subdued>
                <div className="stack-wrapper plan">
                  <Stack alignment="center">
                    <Stack.Item fill>
                      <TextStyle variation="strong">
                        {baseHelper.ucFirst(baseHelper.getPlanBadge(code || name))}
                      </TextStyle>
                      <Caption>
                        <TextStyle variation="subdued">{cms("common.label.planCard.currentPlan")}</TextStyle>

                        {/* <div>
                    <Link url={planURL}>
                      <TextStyle variation="strong">{cms("common.button.upgrade")}</TextStyle>
                    </Link>
                  </div> */}
                      </Caption>
                    </Stack.Item>
                    <Stack.Item>
                      <DisplayText size="small">{`${currentUser.moneyFormat}${price}/m`}</DisplayText>
                    </Stack.Item>
                  </Stack>
                </div>
                <div className="stack-wrapper count">
                  <Stack>
                    <Stack.Item fill>
                      <TextStyle>{cms("common.label.tabs.operator.products")}</TextStyle>
                    </Stack.Item>
                    <Stack.Item>
                      <TextStyle variation="subdued">{`${used}/${maxProduct}`}</TextStyle>
                    </Stack.Item>
                  </Stack>
                  <ProgressBar progress={(used / maxProduct) * 100} size="small" />
                </div>
                <div className="stack-wrapper count">
                  <Stack>
                    <Stack.Item fill>
                      <TextStyle>{cms("common.label.tabs.operator.providers")}</TextStyle>
                    </Stack.Item>
                    <Stack.Item>
                      <TextStyle variation="subdued">{`${associated}/${maxVendor}`}</TextStyle>
                    </Stack.Item>
                  </Stack>
                  <ProgressBar progress={(associated / maxVendor) * 100} size="small" />
                </div>
                <div className="upgrade-button">
                  <Button primary fullWidth url={planURL}>
                    {cms("common.button.upgrade")}
                  </Button>
                </div>
              </Card.Section>
            </InnerCard>
          </Card>
        </Collapsible>
      </StyledPlanCard>
    </Card>
  );
};

export default OperatorPlanCard;
